"use client";

import { buildTrackedPaywallUrl } from "@/lib/paywallUrl";
import { X } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";

export function PromoBanner({ returnTo }: { returnTo: string }) {
  const [isVisible, setIsVisible] = useState(true);
  const [paywallHref, setPaywallHref] = useState(() =>
    buildTrackedPaywallUrl({
      attributionData: null,
      coupon: "Promo33",
      returnTo,
      source: "promo_banner",
    })
  );

  useEffect(() => {
    setPaywallHref(buildTrackedPaywallUrl({ coupon: "Promo33", returnTo, source: "promo_banner" }));
  }, [returnTo]);

  if (!isVisible) return null;

  return (
    <div
      className="relative isolate flex shrink-0 items-center gap-x-6 overflow-hidden bg-[#1C1C1E] px-6 py-2 text-white sm:px-3.5 sm:before:flex-1"
      aria-hidden="false"
    >
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 w-full justify-center">
        <p className="leading-6 text-white text-center">
          <strong className="font-semibold">
            <span className="hidden sm:inline">Limited Time Offer</span>
            <span className="sm:hidden">Limited Offer</span>
          </strong>
          <span className="hidden sm:inline">. Save up to 33% after your free demo</span>
        </p>
        <Link
          href={paywallHref}
          className="flex-none rounded-full bg-[#FD954F] px-3.5 py-1 text-sm font-bold text-[#1C1C1E] shadow-sm transition-colors hover:bg-[#F28747] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#FD954F]"
        >
          See plans <span aria-hidden="true">-&gt;</span>
        </Link>
      </div>
      <div className="flex flex-1 justify-end absolute right-4 top-1/2 -translate-y-1/2 sm:static sm:translate-y-0">
        <button
          type="button"
          className="-m-3 p-3 focus-visible:outline-offset-[-4px]"
          onClick={() => setIsVisible(false)}
        >
          <span className="sr-only">Dismiss</span>
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
